import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { RootState } from "../app/store";
import { logoutUser } from "../features/User/UserSlice";
import { clearDiaryState } from "../features/Diary/DiarySlice";
import "../styles/components/navbar.scss";
import { useState } from "react";

const NavbarScroller = (props: {
  links: Array<{ name: string; to: string }>;
}) => {
  const { links } = props;

  const { isAuth } = useSelector((state: RootState) => state.user);

  const dispatch = useDispatch();
  const [isActive, setActive] = useState(true);
  const history = useHistory();

  return (
    <div className="navbar--parent">
      <div className="navbar">
        <h2
          className="logo"
          onClick={() => {
            history.push("/");
          }}
        >
          Habituate Me
        </h2>
        <div
          className={
            isActive
              ? "navbar--list-container"
              : "navbar--list-container active"
          }
        >
          <ul className="navbar--list">
            {links.map((link: { name: string; to: string }) => (
              <li key={link.name} className="navbar--list-items">
                <Link
                  to={link.to}
                  className="link"
                  onClick={() => dispatch(clearDiaryState())}
                >
                  {link.name}
                </Link>
              </li>
            ))}
            {isAuth ? (
              <li className="navbar--list-items">
                <Link
                  to="/login"
                  onClick={() => {
                    dispatch(logoutUser());
                  }}
                  className="link"
                >
                  Logout
                </Link>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
      <div
        className={!isActive ? "toggle-navbar vertical" : "toggle-navbar"}
        onClick={() => setActive(!isActive)}
      >
        <div className="line--one"></div>
        <div className="line--two"></div>
      </div>
    </div>
  );
};

export default NavbarScroller;
